import React from 'react';

import tataAig1 from "../assets/Images/tataAig.png"
import universal from "../assets/Images/universal-1.png"
import care from "../assets/Images/care-1.webp"
import goDigit from "../assets/Images/digit.png"
import galaxy from "../assets/Images/galaxy_1.png"
import hdfc from "../assets/Images/hdfc-1.png"
import acna from "../assets/Images/acna.png"
import zurich from "../assets/Images/Zurich-Kotak-Logo2024.png"
import future from "../assets/Images/future-1.png"
import reliance from "../assets/Images/reliance.png"
import bajaj from "../assets/Images/bajaj2.png"
import iffco from "../assets/Images/Iffco-tokio-logo-english.webp"
import acko from "../assets/Images/Acko_General_Insurance_logo.svg.png"
import ericson from "../assets/Images/ericson.png"
import libert from "../assets/Images/liberty.png"
import navi from "../assets/Images/Navi Logo.png"
import linkk from "../assets/Images/Link-K-TPA.png"
import healthTpa from "../assets/Images/healthTpa.png"
import park from "../assets/Images/parkTpa.png"
import vison from "../assets/Images/vison.png"
import shape from "../assets/Images/shapes/RightTestimonialThread-01.png"
import shap2 from "../assets/Images/shapes/Thred 06-01.png"
export default function AboutInsuranceCompanies() {
  return (
    <div>
      <div className='max-w-[1340px] mx-auto relative'>
        <div
          className="relative bg-verylightGreen rounded-[24px] py-[80px] lg:py-[160px] px-[24px] md:px-[32px] lg:px-[80px] overflow-hidden bg-no-repeat"
        
        >

          <div className='absolute top-0 left-0'>
            <img src={shape} alt='shape' className='lg:w-[300px] md:w-[200px] w-24'/>
          </div>
          <div className='absolute bottom-0 right-0'>
            <img src={shap2} alt='shape' className='w-[200px]'/>
          </div>
          <div className=" mx-auto text-center mb-[48px]" data-aos="fade-up">
            <h2 className="text-[36px] lg:text-[60px] font-heading text-thickGreen leading-[1.138em] mb-[24px]">
              Your Health - Our Priority

            </h2>
            <p className="text-paraGreen font-body font-medium text-[18px] leading-[1.667em] mb-[16px]">
              All the Medical Insurance we accept/cover <br />
              Get your medical treatments done with easy and hassle-free medical insurance from a wide range of plans
            </p>
          </div>
          <div className="flex flex-row flex-wrap md:gap-2  gap-0 justify-between   items-center ">
            {[
              tataAig1, universal, care, goDigit, galaxy, hdfc, acna, zurich, future, reliance, bajaj, iffco, acko, ericson, libert, navi, linkk, healthTpa, park, vison
            ].map((logo, index) => (
              <div className='xl:w-2/12 lg:w-3/12 md:w-1/4 w-[40%] flex justify-center items-center my-2'> <img key={index} src={logo} alt="Insurance Partner Logo" className="md:w-36 w-24 " />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
